import axios from "axios";
const jsonConfig = require("../../Config.json");


const getAllActiveRequisitions = async (payload) => {
    try {
        const response = await axios.post(jsonConfig.apiUrl + `getAllActiveRequisitions`,payload,{
            headers: {
              "x-functions-key": jsonConfig.key,
            },
        });
        return Promise.resolve(response);
    }
    catch(err) {
        return Promise.reject(err);
    }
}

export default getAllActiveRequisitions;